import { Formik, FormikValues } from "formik";
import React, { useCallback, useMemo } from "react";

import { IM365PulseFormProps } from "./M365PulseForm.types";
import { M365PulseFormChildrenWrapper } from "./M365PulseFormChildrenWrapper";
import { observer } from "mobx-react";
import { schemaDefaults } from "./schemaDefaults";
import { useM365PulseFormValidate } from "./useM365PulseFormValidate";

const M365PulseFormBase = <Values extends FormikValues = FormikValues>({
    children,
    className,
    schema,
    initialValues,
    onValidate,
    onValuesChange,
    ...restProps
}: IM365PulseFormProps<Values>) => {
    const schemaValidate = useM365PulseFormValidate({ schema });
    const validate = useCallback(
        async (values: Values) => {
            const errors = schemaValidate(values);
            const customErrors = onValidate ? await onValidate(values) : {};

            return { ...customErrors, ...errors };
        },
        [onValidate, schemaValidate]
    );

    const value = useMemo(() => {
        if (!initialValues) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const defaultValues: Values = schemaDefaults(schema) as Values;
            return defaultValues;
        }
        return initialValues;
    }, [initialValues, schema]);

    return (
        <div className={className}>
            <Formik validate={validate} initialValues={value} {...restProps}>
                {(props) => (
                    <M365PulseFormChildrenWrapper key={`form-${value.name}`} onValuesChange={onValuesChange} {...props}>
                        {children}
                    </M365PulseFormChildrenWrapper>
                )}
            </Formik>
        </div>
    );
};

export const M365PulseForm = observer(M365PulseFormBase);
